import React from "react"
import {Field} from "react-final-form";
import TextFieldWrapper from "../../Form/TextField";
import {useTranslation} from "react-i18next";

const LastNameField = () => {
    const { t } = useTranslation()

    const validate = {
        lastName: (item: string | null) => {
            if (item) return item.length < 2 ? t('errors.lastName') : ''
            return t('errors.required')
        },
    }

    return (
        <Field name="lastName" type="text" validate={validate.lastName}>
            {(props) => (
                <TextFieldWrapper
                    {...props}
                    fullWidth
                    variant="outlined"
                    required
                    placeholder={t('common.lastName')}
                />
            )}
        </Field>
    )
}

export default LastNameField;
